import { ButtonPrimary } from 'components/Button'
import { Dots } from 'pages/Islands/styleds'
import React, { useState } from 'react'
import { useContext } from 'react'
import { ArrowRight } from 'react-feather'
import { Text } from 'rebass'
import { ThemeContext } from 'styled-components'
import { ThemedText } from 'theme'

import { EarnedItemType, useRewards } from '../../context/RewardContext'
import { InnerCardFlex, IslandCardFlex } from '../../styleds'
import ConfirmationModal from '../modals/ConfirmationModal'
import TransactionError from '../TransactionError'
import EarnedTokenRow from './EarnedTokenRow'

const MigrationCard: React.FC = () => {
  const theme = useContext(ThemeContext)
  const {
    kodiakFarmEarned,
    hasKodiakFarmPositions,
    migration,
    anyTransactionInProgress,
    startMigration,
    unstakeTxState,
    stakeTxState,
    claimTxState,
    rewardVaultRewardToken,
  } = useRewards()

  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const rewardVaultRewardSymbol = rewardVaultRewardToken?.symbol
  const rewardVaultRewardTokenLabel = rewardVaultRewardSymbol || 'Reward'
  const rewardVaultRewardLabel = rewardVaultRewardSymbol ? `${rewardVaultRewardSymbol} rewards` : 'rewards'

  // Get button text based on migration state
  const getButtonText = () => {
    if (migration.completed) {
      return rewardVaultRewardSymbol ? `Claim ${rewardVaultRewardSymbol} Rewards` : 'Claim Rewards'
    } else {
      return migration.inProgress ? 'Migration In Progress' : 'Migrate to Reward Vault'
    }
  }

  const handleMigrationClick = () => {
    setShowConfirmationModal(true)
  }

  const handleConfirmMigration = () => {
    setShowConfirmationModal(false)
    startMigration()
  }

  // Migration steps for the modal
  const migrationSteps = [
    {
      title: 'Unstake your tokens from the Kodiak Farm',
      description: 'Your staked positions will be withdrawn to your wallet',
    },
    {
      title: 'Approve tokens for the Reward Vault',
      description: "you'll need to approve the Reward Vault to access your tokens",
    },
    {
      title: 'Stake your tokens in the Reward Vault',
      description: `Your tokens will be transferred to the Reward Vault to earn ${rewardVaultRewardLabel}`,
    },
  ]

  return (
    <>
      <IslandCardFlex>
        <ThemedText.DeprecatedBody fontSize="14px" fontWeight="400" lineHeight="14px" color={theme.textPrimary}>
          Earned
        </ThemedText.DeprecatedBody>

        {kodiakFarmEarned.length > 0 &&
          kodiakFarmEarned.map((item: EarnedItemType, index: number) => (
            <InnerCardFlex key={index}>
              <EarnedTokenRow key={`${index}-${item.token?.address}`} item={item} />
            </InnerCardFlex>
          ))}

        <ButtonPrimary
          onClick={handleMigrationClick}
          disabled={anyTransactionInProgress || !hasKodiakFarmPositions || migration.completed}
        >
          <Text fontSize={18} fontWeight={500}>
            {getButtonText()}
            {anyTransactionInProgress && <Dots />}
          </Text>
          <ArrowRight size={16} style={{ marginLeft: '8px', opacity: 0.8 }} />
        </ButtonPrimary>

        <TransactionError error={unstakeTxState.error || stakeTxState.error || claimTxState.error} />
      </IslandCardFlex>

      <ConfirmationModal
        isOpen={showConfirmationModal}
        onDismiss={() => setShowConfirmationModal(false)}
        onConfirm={handleConfirmMigration}
        title="Migrate to Reward Vault"
        message={`You're about to migrate your staked tokens from Kodiak Farm to the new Reward Vault to earn ${rewardVaultRewardTokenLabel} token.`}
        steps={migrationSteps}
        confirmText="Start Migration"
        cancelText="Cancel"
      />
    </>
  )
}

export default MigrationCard
